<script>
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import formdate from "../../FormComponet/formdatelimit.vue";
import formcheckbox from "../../FormComponet/formcheckbox1_0.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrRisklerGirislerCevap from "@/models/StrRisklerGirislerCevap";
export default {
  mixins: [Api, Sabit, StrRisklerGirislerCevap],
  props: ["AddEdit", "GirisId","Cevap","KontrolTuru","BirimId","AddEditGiris","Data"],
  data() {
    return {
      FormData: {},
      Loader: false
    };
  },
  components: {
    Loader,
    formcombobox,
    formtextarea,
    BirimSecimi,
    formdate,
    formcheckbox
  },
  watch: {
    AddEdit(){
        if(this.AddEdit == 'Add'){
            this.FormData = this.StrRisklerGirislerCevapData
            this.FormData.Cevaptipi = this.KontrolTuru
            this.FormData.GirisId = this.GirisId;
            this.FormData.BirimId =this.BirimId
        }
      
    },
    Data(){
      if(this.AddEdit == 'Edit'){
          this.FormData = this.Data;
      }
    },
    GirisId(){
      this.FormData.GirisId = this.GirisId;
    },
    KontrolTuru(){
        this.FormData.Cevaptipi = this.KontrolTuru
    },

  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.FormData.Durum = 2;
          this.Post("StrRisklerGirislerCevap", this.FormData).then((res) => {
            if(res){
                this.FormData.Cevap = ""
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrRisklerGirislerCevap");
              
            }
          });
        } else {
        this.Update("StrRisklerGirislerCevap", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrRisklerGirislerCevap");
              this.FormData.Cevap = ""
            }
        });


        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrRisklerGirislerCevap"
      size="m"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrRisklerGirislerCevap.AddEdit.FormTitleEdit')
          : $t('StrRisklerGirislerCevap.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">

        

                  <BirimSecimi v-if="0"
                    :title="FormDataType.BirimId.FieldTitle"
                    :title_position="'mb-3'"
                    :YetkiKontrol="1"
                    :selected="FormData.BirimId"
                    :labels_lg="'3'"  
                    :v="$v.FormData.BirimId"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="FormData.BirimId=$event"
                  />

        
    

        <formcombobox v-if="0"
          :FormDataType="FormDataType.Cevaptipi"
          :Value="FormData.Cevaptipi"
          :v="$v.FormData.Cevaptipi"
          @input="FormData.Cevaptipi = $event"
        />

        <formtextarea v-if="Cevap==1"
          :FormDataType="FormDataType.Cevap"
          :Value="FormData.Cevap"
          :v="$v.FormData.Cevap"
          @input="FormData.Cevap = $event"
        />

        <formdate 
          :title_position="'d-block'"
          :labels_lg="6"
          :min="min_tarih | formatDate"
          :max="max_tarih | formatDate"
          :FormDataType="FormDataType.BaslamaTarihi"
          :Value="this.$options.filters.formatDate(FormData.BaslamaTarihi)"
          :v="$v.FormData.BaslamaTarihi"
          @input="FormData.BaslamaTarihi = $event"
          />

          <formdate 
            :title_position="'d-block'"
            :labels_lg="6"
            :min="min_tarih | formatDate"
            :max="max_tarih | formatDate"
            :FormDataType="FormDataType.BitisTarihi"
            :Value="this.$options.filters.formatDate(FormData.BitisTarihi)"
            :v="$v.FormData.BitisTarihi"
            @input="FormData.BitisTarihi = $event"
            />

        <formtextarea v-if="Cevap != 1"
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        />

        <formcheckbox v-if="0"
          :title_position="'mb-3'"
          :labels_lg="2"
          :FormDataType="FormDataType.Tamamlanma"
          :Value="FormData.Tamamlanma"
          :v="$v.FormData.Tamamlanma"
          @input="FormData.Tamamlanma = $event"
        />

        <button class="btn btn-primary" type="submit">
          {{ $t("StrRisklerGirislerCevap.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
